import * as React from 'react';
import classnames from 'classnames';
import { Heading, Text } from '@grandvisionhq/elements';

const ConfiguratorStepTitleAndDescription = ({ title , description , titleClassName , descriptionClassName , textAlignment ='center' ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "configurator-step-headings"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium",
        align: textAlignment,
        className: classnames('configurator-step-headings__title', titleClassName)
    }, title), description && /*#__PURE__*/ React.createElement(Text, {
        className: classnames('configurator-step-headings__description', descriptionClassName),
        variant: "body",
        align: textAlignment
    }, description));
};

export { ConfiguratorStepTitleAndDescription as default };
//# sourceMappingURL=ConfiguratorStepTitleAndDescription.js.map
